import { render } from "./CommonHorizontalRecipeList.vue?vue&type=template&id=09f1cf36&ts=true"
import script from "./CommonHorizontalRecipeList.vue?vue&type=script&lang=ts"
export * from "./CommonHorizontalRecipeList.vue?vue&type=script&lang=ts"

import "./CommonHorizontalRecipeList.vue?vue&type=style&index=0&id=09f1cf36&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__